/* eslint-disable react/no-danger */
import Head from 'next/head';

const IndexPage = () => {
  if (process.browser) return null;

  const blazePreconnectOrigin = process.env.BLAZE_GRAPHQL_URI.slice(0, -8);

  return (
    <Head>
      <meta name="facebook-domain-verification" content="540hnzc43x31yhm21x1ox4130kp9e2" />
      <link rel="preconnect" href="https://cdn.dockwalk.com" />
      <link rel="preconnect" href={blazePreconnectOrigin} />

      <link
        rel="preload"
        href="/static/fonts/RomainText.woff2"
        as="font"
        crossOrigin="anonymous"
        type="font/woff2"
      />
      <link
        rel="preload"
        href="static/fonts/apercu-condensed-medium-pro.woff2"
        as="font"
        crossOrigin="anonymous"
        type="font/woff2"
      />
      <link
        rel="preload"
        href="/static/fonts/apercu-condensed-medium-italic-pro.woff2"
        as="font"
        crossOrigin="anonymous"
        type="font/woff2"
      />
      <link
        rel="preload"
        href="/static/fonts/Austin-Medium-Cy-Web.woff2"
        as="font"
        crossOrigin="anonymous"
        type="font/woff2"
      />

      <link
        rel="preload"
        href="https://use.fontawesome.com/releases/v5.8.1/css/all.css"
        as="style"
      />
      <link
        rel="preload"
        href="https://fonts.googleapis.com/icon?family=Material+Icons&amp;display=swap"
        as="style"
      />

      <script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-TGV5FD2');`
        }}
      />

      <script
        dangerouslySetInnerHTML={{
          __html: `
            document.addEventListener('click', function(e) {
              var toggleExpandedFilterDesktop = function(target) {
                var wasOpen = target.classList.contains('open');

                var toClose = document.querySelectorAll('.bi-search-bar .filter__more-filters-desktop-wrapper.filter__more-filters-desktop-wrapper--open .filter__more-filters-desktop-content > .open');
                for (var i = 0; i < toClose.length; i++) {
                  toClose[i].classList.remove('open');
                }

                if (!wasOpen) target.classList.add('open');
              };

              var toggleExpandedFilterMobile = function(target) {
                var wasOpen = target.classList.contains('open');

                var toCloseDesktop = document.querySelectorAll('.bi-search-bar .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-desktop-content > .open');
                for (var i = 0; i < toCloseDesktop.length; i++) {
                  toCloseDesktop[i].classList.remove('open');
                }

                var toCloseMobile = document.querySelectorAll('.bi-search-bar .filter__more-filters-mobile-wrapper.filter__more-filters-mobile-wrapper--open .filter__more-filters-mobile-content > .open');
                for (var i = 0; i < toCloseMobile.length; i++) {
                  toCloseMobile[i].classList.remove('open');
                }

                if (!wasOpen) target.classList.add('open');
              };

              if (window.artificialClick) {
                window.artificialClick = false;
                return;
              }

              var foundSearchBarTextInput = false;
              var foundSearchBarLength = false;
              var foundSearchBarPriceYfs = false;
              var foundSearchBarPriceYfc = false;
              var foundSearchBarYearOfBuildYfs = false;
              var foundSearchBarDestinationsYfc = false;
              var foundMoreFiltersDesktop = false;
              var foundMoreFiltersMobile = false;
              var foundSearchBarYearOfBuildSyd = false;
              var foundSearchBarBuildersSyd = false;
              var foundSearchBarTopSpeedSyd = false;

              var target;



              for (target = e.target; target && target != this; target = target.parentNode) {
                if (target.matches('.bi-yacht-specs-full--togglable .heading--section')) {
                  target.parentNode.classList.toggle('bi-yacht-specs-full__open-section');
                  break;
                }


              }

              for (target = e.target; target && target != this; target = target.parentNode) {
                if (target.matches('.bi-search-bar .filter__more-filters-mobile-buttons > .button--full-width')) {
                  foundMoreFiltersMobile = false;
                  break;
                }

                if (target.matches('.bi-search-bar .filter__more-filters-desktop-buttons > .button--full-width')) {
                  foundMoreFiltersDesktop = false;
                  break;
                }
              }

              if (!foundSearchBarTextInput) {
                var toRemoveSearchBarTextInput = document.querySelector('.filter__more-filters-mobile-content > .filter__section.bi-search-bar__filter--open:first-child');
                if (toRemoveSearchBarTextInput) {
                  toRemoveSearchBarTextInput.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarLength) {
                var toRemoveSearchBarLength = document.querySelector('.filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(2)');
                if (toRemoveSearchBarLength) {
                  toRemoveSearchBarLength.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarPriceYfs) {
                var toRemoveSearchBarPriceYfs = document.querySelector('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(3)');
                if (toRemoveSearchBarPriceYfs) {
                  toRemoveSearchBarPriceYfs.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarPriceYfc) {
                var toRemoveSearchBarPriceYfc = document.querySelector('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(3)');
                if (toRemoveSearchBarPriceYfc) {
                  toRemoveSearchBarPriceYfc.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarYearOfBuildSyd) {
                var toRemoveSearchBarYearOfBuildSyd = document.querySelector('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(3)');
                if (toRemoveSearchBarYearOfBuildSyd) {
                  toRemoveSearchBarYearOfBuildSyd.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarTopSpeedSyd) {
                var toRemoveSearchBarTopSpeedSyd = document.querySelector('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(4)');
                if (toRemoveSearchBarTopSpeedSyd) {
                  toRemoveSearchBarTopSpeedSyd.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarYearOfBuildYfs) {
                var toRemoveSearchBarYearOfBuildYfs = document.querySelector('.bi-search-bar.bi-search-bar--yfs .filter__more-filters-mobile-content > .range-slider__wrapper.bi-search-bar__filter--open:nth-child(4)');
                if (toRemoveSearchBarYearOfBuildYfs) {
                  toRemoveSearchBarYearOfBuildYfs.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarDestinationsYfc) {
                var toRemoveSearchBarDestinationsYfc = document.querySelector('.bi-search-bar.bi-search-bar--yfc .filter__more-filters-mobile-content > .filter__section.bi-search-bar__filter--open:nth-child(4)');
                if (toRemoveSearchBarDestinationsYfc) {
                  toRemoveSearchBarDestinationsYfc.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundSearchBarBuildersSyd) {
                var toRemoveSearchBarBuildersSyd = document.querySelector('.bi-search-bar.bi-search-bar--syd .filter__more-filters-mobile-content > .filter__section.bi-search-bar__filter--open:nth-child(4)');
                if (toRemoveSearchBarBuildersSyd) {
                  toRemoveSearchBarBuildersSyd.classList.remove('bi-search-bar__filter--open');
                }
              }

              if (!foundMoreFiltersDesktop) {
                var toRemoveMoreFiltersDesktopToggler = document.querySelector('.bi-search-bar .filter__more-filters-desktop-toggler--open');
                if (toRemoveMoreFiltersDesktopToggler) {
                  window.artificialClick = true;
                  toRemoveMoreFiltersDesktopToggler.click();
                }
              }

              if (!foundMoreFiltersMobile) {
                var toRemoveMoreFiltersMobileToggler = document.querySelector('.bi-search-bar .filter__more-filters-mobile-toggler--open');
                if (toRemoveMoreFiltersMobileToggler) {
                  window.artificialClick = true;
                  toRemoveMoreFiltersMobileToggler.click();
                }
              }
            }, false);
          `
        }}
      />
    </Head>
  );
};

export default IndexPage;
